import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import List from './list.vue'
import Edit from './editor.vue'
import Layout from '../layout.vue'

const basePath = '/v-admin/agency/management'

export default {
  name: 'agencyManagement',
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_VENDOR_MANAGERMENT', 'PREMIUM_VENDOR_MANAGEMENT'],
    titleI18nKey: 'admin.company.agency.title',
    menu: {
      get label () {
        return i18n.t('admin.company.agency.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.agency.title'
      }
    },
    {
      path: `${basePath}/add`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: false,
        titleI18nKey: 'admin.company.agency.agencyAdd'
      }
    },
    {
      path: `${basePath}/edit/:agencyId`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: true,
        titleI18nKey: 'admin.company.agency.agencyEdit'
      }
    }
  ]
}
